'use strict'

document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Vars
   *******************************/
  const html = document.querySelector('html');
  const body = document.querySelector('body');
  const screenWidth = window.innerWidth;

  /********************************
   * Our Approach
   *******************************/
  const sectionOurApproach = document.querySelectorAll('.our-approach');

  if (sectionOurApproach.length) {
    /***** slider *****/
    function startSlider(sliderInit) {
      new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1.1,
        spaceBetween: 6,
        loop: true,

        navigation: {
          nextEl: ".btn-next",
          prevEl: ".btn-prev",
        },

        pagination: {
          clickable: true,
          el: ".swiper-pagination",
        },
      });
    }

    function initializeSlider(slider, slideCount) {
      if (!slider) return;

      if (screenWidth <= 767 && slideCount > 1) {
        startSlider(slider);
        slider.closest('.column-slider')?.classList.add('slider-active');
      }
    }

    /***** video *****/
    function initializeVideo(columnMedia) {
      const videoElement = columnMedia.querySelector('video.video');
      if (!videoElement) return;

      const playButton = columnMedia.querySelector('.video-play');
      const soundButton = columnMedia.querySelector('.video-sound');

      videoElement.muted = true;

      const setPlayingState = (isPlaying) => {
        columnMedia.classList.toggle('is-playing', isPlaying);
      };

      const setSoundState = (isSoundOn) => {
        columnMedia.classList.toggle('is-sound-on', isSoundOn);
      };

      const togglePlay = () => {
        const isPlayingNow = !videoElement.paused && !videoElement.ended;

        if (isPlayingNow) {
          videoElement.pause();
          setPlayingState(false);
          return;
        }

        const playPromise = videoElement.play();
        setPlayingState(true);

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            setPlayingState(false);
          });
        }
      };

      if (playButton) {
        playButton.addEventListener('click', (event) => {
          event.preventDefault();
          togglePlay();
        });
      }

      if (soundButton) {
        soundButton.addEventListener('click', (event) => {
          event.preventDefault();

          videoElement.muted = !videoElement.muted;
          setSoundState(!videoElement.muted);
        });
      }

      videoElement.addEventListener('click', (event) => {
        event.preventDefault();
        togglePlay();
      });

      videoElement.addEventListener('pause', () => setPlayingState(false));
      videoElement.addEventListener('ended', () => setPlayingState(false));
      videoElement.addEventListener('play', () => setPlayingState(true));

      setPlayingState(false);
      setSoundState(!videoElement.muted);
    }

    sectionOurApproach.forEach(section => {
      const slider = section.querySelector('.slider_init');
      const slideCount = section.querySelectorAll('.swiper-slide').length;

      initializeSlider(slider, slideCount);

      const mediaColumns = section.querySelectorAll('.column-media');
      mediaColumns.forEach(columnMedia => {
        initializeVideo(columnMedia);
      });
    });
  }

  /********************************
   * Info Cards
   *******************************/
  const sectionCardsInfo = document.querySelectorAll('.info-cards');

  if (sectionCardsInfo.length) {
    function initializeSlider(slider, slideCount) {
      if (screenWidth <= 991 && slideCount > 1) {
        startSlider(slider);
      }
    }

    function startSlider(sliderInit) {
      new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1.1,
        spaceBetween: 6,

        breakpoints: {
          320: {
            slidesPerView: 1.1,
          },
          767: {
            slidesPerView: 2.1,
          },
          991: {
            slidesPerView: 2.8,
          }
        },

        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
        },
      });
    }

    sectionCardsInfo.forEach(section => {
      const slider = section.querySelector('.slider_init');
      const slideCount = section.querySelectorAll('.swiper-slide').length;

      initializeSlider(slider, slideCount)
    });
  }

  /********************************
   * Media Slider
   *******************************/
  const sectionMediaSlider = document.querySelectorAll('.media-slider');

  if (sectionMediaSlider.length) {

    function startSlider(sliderInit) {
      new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1.1,
        spaceBetween: 10,
        loop:true,

        breakpoints: {
          767: {
            spaceBetween: 16,
            slidesPerView: 1.1,
          },
          992: {
            spaceBetween: 24,
            slidesPerView: 2,
          },
          1200: {
            spaceBetween: 33,
            slidesPerView: 2,
          }
        },

        navigation: {
          nextEl: ".btn-next",
          prevEl: ".btn-prev",
        },

        pagination: {
          clickable: true,
          el: ".swiper-pagination",
        },
      });
    }

    sectionMediaSlider.forEach(section => {
      startSlider(section.querySelector('.slider_init'));
    });
  }

  /********************************
   * Hero + Info Cards
   *******************************/
  const heroInfoCards = document.querySelectorAll('.hero-info-cards');

  if (heroInfoCards.length) {
    function initializeSlider(slider, slideCount, container) {
      if (screenWidth <= 992 && slideCount > 1) {
        container.classList.add('slider-active');
        startSlider(slider, container);
      }
    }

    function startSlider(sliderInit) {
      new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1.05,
        spaceBetween: 6,
        loop: true,

        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            spaceBetween: 10,
            slidesPerView: 3,
          }
        },

        navigation: {
          nextEl: ".btn-next",
          prevEl: ".btn-prev",
        },

        pagination: {
          clickable: true,
          el: ".swiper-pagination",
        },
      });
    }

    heroInfoCards.forEach(section => {
      const container = section.querySelector('.container');
      const slider = section.querySelector('.slider_init');
      const slideCount = section.querySelectorAll('.swiper-slide').length;

      initializeSlider(slider, slideCount, container)
    });
  }

  /********************************
   * Accordion: FAQ
   *******************************/
  const accordionGroup = document.querySelectorAll('.accordion-wrap');

  if (accordionGroup.length >= 1) {
    accordionGroup.forEach(accordion => {
      if (accordion.classList.contains('open-first-child')) {
        setTimeout(() => {
          const accordionItem = accordion.querySelector('.accordion-item');
          const customPadding = +accordionItem.dataset.descriptionPadding || 24;
          const accordionContent = accordionItem.querySelector('.accordion-description');

          accordionItem.classList.add('active');
          accordionContent.style.height = (accordionItem.querySelector('.accordion-inner-content').scrollHeight + customPadding) + "px";
        }, 1300)
      }

      if (accordion.classList.contains('open-all-child')) {
        setTimeout(() => {
          const accordionItems = accordion.querySelectorAll('.accordion-item');
          accordionItems.forEach(accordionItem => {
            const customPadding = +accordionItem.dataset.descriptionPadding || 24;
            const accordionContent = accordionItem.querySelector('.accordion-description');

            accordionItem.classList.add('active');
            accordionContent.style.height = (accordionContent.querySelector('.accordion-inner-content').scrollHeight + customPadding) + "px";
          });
        }, 1300);
      }

      accordion.addEventListener('click', function ({target}) {
        const accordionActive = accordion.querySelector('.accordion-item.active');
        const accordionItem = target.closest('.accordion-item');
        const customPadding = +accordionItem.dataset.descriptionPadding || 24;
        console.log(accordionItem.dataset.descriptionPadding, customPadding)
        const accordionContent = accordionItem.querySelector('.accordion-description');

        if (target.closest('.accordion-description')) {
          return false;
        }

        if (accordionItem.classList.contains('active')) {
          accordionItem.classList.remove('active');
          accordionContent.style.height = 0 + 'px';
        } else {
          if (accordionActive) {
            accordionActive.classList.remove('active');
            accordionActive.querySelector('.accordion-description').style.height = 0 + 'px';
          }

          accordionItem.classList.add('active');
          accordionContent.style.height = (accordionContent.querySelector('.accordion-inner-content').scrollHeight + customPadding) + "px";
        }
      });
    })
  }

  /********************************
   * Featured Product
   *******************************/
  const featuredProductSections = document.querySelectorAll('.featured-product');

  const initializeUGC = (ugcSliderElement) => {
    if (ugcSliderElement.dataset.ugcInitialized === '1') return;
    ugcSliderElement.dataset.ugcInitialized = '1';

    const sectionElement = ugcSliderElement.closest('.featured-product');
    if (!sectionElement) return;

    const popupElement = sectionElement.querySelector('.ugc-popup');
    const videoBoxElement = popupElement ? popupElement.querySelector('.video-box') : null;

    const slideElements = Array.from(ugcSliderElement.querySelectorAll('.swiper-slide[data-ugc-item]'));
    const slideCount = slideElements.length;

    if (!popupElement || !videoBoxElement || slideCount === 0) return;

    let currentIndex = 0;

    const stopAndClearPopupVideo = () => {
      const videoElement = videoBoxElement.querySelector('video');
      if (videoElement) {
        try { videoElement.pause(); } catch (e) {}
      }
      videoBoxElement.innerHTML = '';
    };

    const openPopup = () => {
      popupElement.classList.add('show');
      popupElement.setAttribute('aria-hidden', 'false');
    };

    const closePopup = () => {
      stopAndClearPopupVideo();
      popupElement.classList.remove('show');
      popupElement.setAttribute('aria-hidden', 'true');
    };

    const renderAndPlayVideoByIndex = (index) => {
      const normalizedIndex = ((index % slideCount) + slideCount) % slideCount;
      currentIndex = normalizedIndex;

      const slideElement = slideElements[normalizedIndex];
      const videoUrl = slideElement.dataset.videoUrl;
      const posterUrl = slideElement.dataset.poster;

      stopAndClearPopupVideo();

      if (!videoUrl) return;

      const videoElement = document.createElement('video');
      videoElement.className = 'ugc-popup-video';
      videoElement.playsInline = true;
      videoElement.preload = 'metadata';
      videoElement.muted = false;
      videoElement.autoplay = true;
      videoElement.controls = true;
      /*videoElement.controls = false;
      videoElement.setAttribute('controlslist', 'nodownload noplaybackrate');*/

      if (posterUrl) videoElement.setAttribute('poster', posterUrl);

      const sourceElement = document.createElement('source');
      sourceElement.src = videoUrl;
      sourceElement.type = 'video/mp4';

      videoElement.appendChild(sourceElement);
      videoBoxElement.appendChild(videoElement);

      const playPromise = videoElement.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const openPopupFromSlide = (slideElement) => {
      const indexAttr = slideElement.getAttribute('data-index');
      const index = indexAttr ? parseInt(indexAttr, 10) : slideElements.indexOf(slideElement);
      if (Number.isNaN(index) || index < 0) return;

      openPopup();
      renderAndPlayVideoByIndex(index);
    };

    const previousButton = popupElement.querySelector('.video-prev');
    const nextButton = popupElement.querySelector('.video-next');
    const closeButton = popupElement.querySelector('.popup-close');
    const popupOverflow = popupElement.querySelector('.ugc-popup-overflow');

    if (previousButton) {
      previousButton.addEventListener('click', (event) => {
        event.preventDefault();
        renderAndPlayVideoByIndex(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        renderAndPlayVideoByIndex(currentIndex + 1);
      });
    }

    if (closeButton || popupOverflow) {
      popupOverflow.addEventListener('click', (event) => {
        event.preventDefault();
        closePopup();
      });

      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        closePopup();
      });
    }

    popupElement.addEventListener('click', (event) => {
      if (event.target === popupElement) closePopup();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popupElement.classList.contains('show')) closePopup();
    });

    if (slideCount > 3) {
      ugcSliderElement.closest('.ugc-wrap')?.classList.add('slider-active');

      new Swiper(ugcSliderElement, {
        slidesPerView: 3,
        spaceBetween: 10,
        threshold: 10,
        breakpoints: {
          768: { slidesPerView: 3.1 }
        },
        on: {
          click(swiper, event) {
            const slideElement = event.target.closest('.swiper-slide[data-ugc-item]');
            if (slideElement) openPopupFromSlide(slideElement);
          }
        }
      });
    } else {
      ugcSliderElement.addEventListener('click', (event) => {
        const slideElement = event.target.closest('.swiper-slide[data-ugc-item]');
        if (slideElement) openPopupFromSlide(slideElement);
      });
    }
  };

  if (featuredProductSections.length >= 1) {

    featuredProductSections.forEach(section => {

      /********************************
       * Slider (optional)
       *******************************/
      const mainEl = section.querySelector('.slider_main_init');
      const thumbsEl = section.querySelector('.slider_thumbs_init');

      let thumbsSwiper = null;

      if (mainEl && thumbsEl) {
        const slidesCount = mainEl.querySelectorAll('.swiper-slide').length;

        if (slidesCount > 1) {
          thumbsSwiper = new Swiper(thumbsEl, {
            spaceBetween: 10,
            slidesPerView: 5,
            watchSlidesProgress: true,
            slideToClickedSlide: true,

            breakpoints: {
              768: {
                slidesPerView: 7
              },
              1200: {
                slidesPerView: 9
              }
            },
          });

          new Swiper(mainEl, {
            slidesPerView: 1,
            thumbs: {
              swiper: thumbsSwiper
            },

            navigation: {
              nextEl: thumbsEl.querySelector('.btn-next'),
              prevEl: thumbsEl.querySelector('.btn-prev')
            }
          });
        }
      }

      /********************************
       * Add to cart + price
       *******************************/
      const formProducts = section.querySelector('.form-products');
      const priceHolder = section.querySelector('.product-price');
      const customButton = section.querySelector('.btn-product');

      if (formProducts) {

        const extractPrice = () => {
          const submitBtn = formProducts.querySelector('button[type="submit"] span span');
          if (!submitBtn || !priceHolder) return;

          const price = submitBtn.textContent.trim();

          if (price) {
            priceHolder.textContent = price;
            priceHolder.classList.add('show');

            if(!priceHolder.closest('.product-price-wrap').classList.contains('show')){
              priceHolder.closest('.product-price-wrap').classList.add('show');
            }
          }
        };

        const hookCustomButton = () => {
          if (!customButton || customButton.dataset.bound) return;

          customButton.dataset.bound = '1';

          customButton.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();

            const submitBtn = formProducts.querySelector('button[type="submit"]');
            if (submitBtn) submitBtn.click();
          });
        };

        const observer = new MutationObserver(() => {
          const reactForm = formProducts.querySelector('react-product-form');
          if (!reactForm) return;

          extractPrice();
          hookCustomButton();
        });

        observer.observe(formProducts, {
          childList: true,
          subtree: true
        });

        extractPrice();
        hookCustomButton();
      }

      /********************************
       * Popups
       *******************************/
      const closeAllPopups = () => {
        section.querySelectorAll('.info-popup').forEach(p => {
          p.classList.remove('show');
          p.setAttribute('aria-hidden', 'true');
        });
      };

      const openPopupByType = type => {
        if (!type) return;

        const popup = section.querySelector(`.info-popup.type-${type}`);
        if (!popup) return;

        closeAllPopups();
        popup.classList.add('show');
        popup.setAttribute('aria-hidden', 'false');
      };

      section.addEventListener('click', e => {
        const trigger = e.target.closest('.popup-trigger');

        if (trigger) {
          const typeClass = [...trigger.classList].find(c => c.startsWith('type-'));
          const type = typeClass?.replace('type-', '');
          openPopupByType(type);
          return;
        }

        if (e.target.closest('.popup-close') || e.target.closest('.popup-overflow')) {
          closeAllPopups();
          return;
        }

        const popup = e.target.closest('.info-popup');
        if (popup && e.target === popup) closeAllPopups();
      });

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') closeAllPopups();
      });

      /********************************
       * UGC
       *******************************/
      const ugcSliderElement = section.querySelector('.ugc_init');
      if (ugcSliderElement) initializeUGC(ugcSliderElement);
    });
  }

  /********************************
   * Cart Items: Add data-sku attributes
   *******************************/
  const addSkuAttributesToCartItems = async () => {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (!cart.items || cart.items.length === 0) return;

      // Create a map of variant_id to sku
      const skuMap = new Map();
      cart.items.forEach(item => {
        if (item.sku) {
          skuMap.set(item.variant_id, item.sku);
          skuMap.set(item.id, item.sku); // Also map by line item id
        }
      });

      // Find cart line items in DOM and add data-sku
      const lineItems = document.querySelectorAll('[class*="lineitem"]');
      lineItems.forEach((element, index) => {
        const item = cart.items[index];
        if (item && item.sku && !element.hasAttribute('data-sku')) {
          element.setAttribute('data-sku', item.sku);
        }
      });

      // Also try to match by finding the contents__item wrapper
      const contentsItems = document.querySelectorAll('[class*="contents__item"]');
      contentsItems.forEach((element, index) => {
        const item = cart.items[index];
        if (item && item.sku) {
          element.setAttribute('data-sku', item.sku);
          // Also set on the lineitem child if exists
          const lineItem = element.querySelector('[class*="lineitem"]');
          if (lineItem) {
            lineItem.setAttribute('data-sku', item.sku);
          }
        }
      });
    } catch (error) {
      console.warn('Failed to add SKU attributes to cart items:', error);
    }
  };

  // Observe cart drawer/page for changes and add SKU attributes
  const observeCartForSkuAttributes = () => {
    const cartContainers = document.querySelectorAll('react-cart, [data-section-name="cart"]');
    
    if (cartContainers.length === 0) return;

    const observer = new MutationObserver((mutations) => {
      // Debounce the SKU attribute addition
      clearTimeout(window._skuAttributeTimeout);
      window._skuAttributeTimeout = setTimeout(addSkuAttributesToCartItems, 100);
    });

    cartContainers.forEach(container => {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    });

    // Initial run
    addSkuAttributesToCartItems();
  };

  // Initialize cart SKU observer
  observeCartForSkuAttributes();

  // Also listen for custom cart events if any
  document.addEventListener('cart:updated', addSkuAttributesToCartItems);
  document.addEventListener('cart:drawer:opened', () => {
    setTimeout(addSkuAttributesToCartItems, 200);
  });

  /********************************
   * Featured Product + Sticky Product visibility
   *******************************/
  const stickyProduct = document.querySelector('.sticky-product');

  if (featuredProductSections.length >= 1 && stickyProduct) {
    const updateSticky = (isAnyFeaturedInView) => {
      stickyProduct.classList.toggle('show', !isAnyFeaturedInView);
    };

    const inViewMap = new Map();

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          inViewMap.set(entry.target, entry.isIntersecting);
        });

        const isAnyFeaturedInView = Array.from(inViewMap.values()).some(Boolean);
        updateSticky(isAnyFeaturedInView);
      },
      {
        threshold: 0,
        root: null
      }
    );

    featuredProductSections.forEach((section) => {
      inViewMap.set(section, false);
      io.observe(section);
    });

    updateSticky(false);
  }

});